export const GA_TRACKING_ID = process.env.ENV === "production" ? "UA-47454572-4" : "UA-XXXXXXXX-X"
export const GTM_ID = process.env.ENV === "production" ? "GTM-MGFW44C" : (process.env.GTM_ID || "GTM-XXXXXXX")
export const GOP_ID = process.env.ENV === "production" ? "GTM-T6TM25V" : "GTM-XXXXXXX"
export const GA4_ID = process.env.ENV === "production" ? "G-W13EWPJJMP" : (process.env.GA4_ID || "G-XXXXXXXXXX")

export const trackPageView = (url: string) => {
  if (typeof window !== "undefined") {
    try {
      window.gtag("config", GA_TRACKING_ID, {
        page_path: url,
      })
    } catch (error) {
      console.log("trackPageView error")
    }
  }
}

export const pushUserIdToDataLayer = (userId: number) => {
  if (typeof window !== "undefined") {
    try {
      window.dataLayer.push({
        user_id: userId,
      })
    } catch (error) {
      console.log("pushUserIdToDataLayer error")
    }
  }
}

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window !== "undefined") {
    try {
      window.gtag("event", eventName, {send_to: GA4_ID, ...(params || {})})
    } catch (error) {
      console.log("trackEvent error", error)
    }
  }
}
